<form [formGroup]="formGroup">
  @if (!formGroup.get('bannerClosed').value) {
    <pdq-banner
      variant="regular"
      class="banner"
      bannerTitle="Pay Attention"
      content="To ensure the extension works correctly, add this block to the checkout page and the thank you page."
      (onButtonClick)="onCloseBanner()"
      button="Don't Show Again"
      [closable]="false"
      variantButton="light">
    </pdq-banner>
  }
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h5">Token for Shopify</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-link
          label="View detailed installation instructions"
          [external]="true"
          [url]="'https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components'"></pdq-link>
        <pdq-input
          [disabled]="true"
          [formControl]="formGroup.get('usageToken')"
          label="Copy & paste this into Shopify's components by 'Embedded Offers token'"
          [clipboard]="true"></pdq-input>
        <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h5">General</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-input
          label="Internal name"
          [formControl]="formGroup.get('title')"
          [invalid]="formGroup.get('title')?.errors?.required"
          invalidMsg="Internal name is required"></pdq-input>
        <pdq-input
          label="Internal description"
          [formControl]="formGroup.get('internalName')"
          placeholder="Description..."></pdq-input>
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h5">Display rules</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-rules-dynamic-form
          [formGroup]="formGroup"
          formArrayFieldName="restrictionsRules"
          [rules]="restrictionsRules | addCurrencyOption: shopCurrencySymbol"
          [entities]="entities"
          [shopCurrencySymbol]="shopCurrencySymbol"
          [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div class="historical-payment-data-container">
        <pdq-slide-toggle
          [formControl]="formGroup.get('useHistoricalData')"
          label="Use historical data"
          [subtext]="historicalPaymentDataSubtext"
          togglePosition="right"
          [fullWidth]="true"
          [disabled]="isHistoricalPaymentDataToggleDisabled"
          [locked]="isHistoricalPaymentDataToggleLocked">
        </pdq-slide-toggle>
        @if (historicalPaymentDataTooltip) {
          <pdq-icon
            icon="more_information"
            color="var(--on-surface-light)"
            class="historical-data-info-icon"
            #infoTooltip="matTooltip"
            [matTooltip]="historicalPaymentDataTooltip"
            matTooltipClass="pdq-mat-tooltip"
            matTooltipPosition="above"
            (click)="infoTooltip.toggle()">
          </pdq-icon>
        }
      </div>
    </div>
  </pdq-card>
</form>
